import axios from "axios";
import config from "./config";

const BASE = `${config.url}/accounting/accounts`;

function adminHeaders() {
  return { Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}` };
}

export const AccountsService = {
  async list(memberId) {
    const { data } = await axios.get(`${BASE}/${memberId}`, { headers: adminHeaders() });
    return data?.accounts || data || [];
  },
};
